<template>
    <div v-cloak>
        <div class="loader overflow" :class="{ 'loader-topmost': buyDialog }" v-if="nOpenDialogs != 0" />

        <!-- GENERIC DIALOGS-->
        <GroupDialog v-if="group" :group="group" />
        <UserDialog v-if="user" :user="user" :checkTFA=checkTFA />
        <PolicyDeviceDialog v-if="device" :device="device" :policiesList="policiesList" />
        <PolicyDialog v-if="policy" :computers="computers" :policy="policy" />
		<ScriptDeploy v-if="scriptDeployment" :scriptDeployment="scriptDeployment" />
        <SchedulationDialog v-if="openSched" :cronSchedulation="cronSchedulation" />
        <TeamDialog v-if="team" :team="team" />
        <CustomerDialog v-if="customer" :customer="customer" />
        <AssignGroupsToCustomers v-if="assignGroupsToCustomers" />
        <InvoiceDialog v-if="invoice && createInvoiceMode" :invoice="invoice" :mode="createInvoiceMode"/>
        <InvoiceView v-if="invoiceView" :invoice="invoiceView" />
        <ExpiredLicenceAlert v-if="expiredLicenceAlert" />

        <!-- <ComputerAgentDialog  v-if="createagent"  /> -->

        <!--------------------------------BACKUP - DESTINAZIONI--------------------------------------------------------------->
        <Destination v-if="destination != null" :destination="destination" class="destinationDialog" />
        <!--------------------------------BACKUP - SORGENTI--------------------------------------------------------------->
        <template v-if="source != null">
            <FolderSource v-if="source.type == $ONEServiceType.FileFolder" :source="source" class="sourceDialog" />

            <NetworkSource v-if="source.type == $ONEServiceType.Network" :source="source" class="sourceDialog" />

            <!--Vengono nascoste se la finestra del service account viene aperta-->
            <DriveImageSource v-if="source.type == $ONEServiceType.DriveImage" :bkpSource="source" />

            <HyperVSource v-if="source.type == $ONEServiceType.HyperV" v-show="serviceAccount == null" :source="source" />

            <ESXiSourceDestination v-if="source.type == $ONEServiceType.ESXi" v-show="serviceAccount == null" :source="source" class="sourceDialog" />

            <ExchangeSource v-if="source.type.isExchange()" v-show="serviceAccount == null" :source="source" class="sourceDialog" />

            <DatabaseSource v-if="source.type.isDatabase()" v-show="serviceAccount == null" :source="source" class="sourceDialog" />

            <MicrosoftSource v-if="source.type.isMicrosoft365() && !source.type.isExchange()" v-show="serviceAccount == null" :source="source" class="sourceDialog" />

        </template>
        <!--------------------------RESTORE------------------------------------------------------------------------------->
        <template v-if="restore != null">
            <RestoreFile v-if="restore.type.isSimpleFileNFolderType()" v-show="serviceAccount == null && repository == null" :restore="restore" class="restoreDialog" />
            <HyperVRestore v-if="restore.type == $ONEServiceType.HyperV" :restore="restore" class="restoreDialog" />

            <!------------------------RESTORE - MANUAL------------------------------------------------------------->
            <div v-if="!isValid(restore.idBackup)" v-show="serviceAccount == null">
                <ESXiManualRestore v-if="restore.type == $ONEServiceType.ESXi" :source="restore" class="restoreDialog" />

                <DatabaseManualRestore v-if="restore.type == $ONEServiceType.Database_SQLServer" :source="restore" class="restoreDialog" />
            </div>

            <ExchangeRestore v-if="restore.type.isExchange()" :restore="restore" class="restoreDialog" />

            <!------------------------RESTORE - AUTOMATIC------------------------------------------------------------->
            <div v-if="isValid(restore.idBackup)" v-show="serviceAccount == null">
                <ESXiDestinationRestore v-if="restore.type == $ONEServiceType.ESXi" :idJob="selectedJobId" :idPC="$session.getRoomPC().id" class="restoreDialog" />
                <DatabaseDestinationRestore v-if="restore.type == $ONEServiceType.Database_SQLServer" :idJob="restore.idBackup" :idPC="$session.getRoomPC().id" class="restoreDialog" />
            </div>
        </template>
        <!--------------------------VISTE----------------------------------------------------------------->
        <BackupView v-if="backupView != null" :job="backupView" />

        <RestoreView v-if="restoreView != null" :restoreJob="restoreView" />


        <!------------------------REPOSITORY--------------------------------------------->
        <Repository v-if="isValid(repository)" :repository="repository" class="repositoryDialog" />

        <!--------------------------SERVICE ACCOUNTS-------------------------------------->
        <template v-if="isValid(serviceAccount)">
            <CloudServiceAccount v-if="serviceAccount.type.isCloud() && serviceAccount.type != $ONEServiceType.Cloud_OneDrive" :serviceAccount="serviceAccount" class="saDialog" />
            <FTPServiceAccount v-if="serviceAccount.type == $ONEServiceType.FTP" :serviceAccount="serviceAccount" class="saDialog" />
            <NetworkServiceAccount v-if="serviceAccount.type == $ONEServiceType.Network" :serviceAccount="serviceAccount" class="saDialog" />
            <ESXIServiceAccount v-if="serviceAccount.type == $ONEServiceType.ESXi" :serviceAccount="serviceAccount" class="saDialog" />
            <!--Exchange + onedrive + sharepoint + teams-->
            <MicrosoftServiceAccount v-if="serviceAccount.type.isMicrosoft() || serviceAccount.type == $ONEServiceType.Cloud_OneDrive" :serviceAccount="serviceAccount" class="saDialog" />
            <DatabaseServiceAccount v-if="serviceAccount.type.isDatabase()" :serviceAccount="serviceAccount" class="saDialog" />
            <EmailServiceAccount v-if="serviceAccount.type.isEmail()" :serviceAccount="serviceAccount" class="saDialog" />
        </template>

        <SARepoView v-if="sarepo != null" :repository="sarepo.repository" :serviceAccount="sarepo.serviceAccount" />

        <!--------------------------FINESTRA PER RINOMINARE UNA CARTELLA O UN FILE-------------------------------->
        <div v-if="renameItemDialog != null" class="dialog light">
            <div class="dialog-title pl-10">{{ $t("Rename") }}</div>
            <div class="d-flex flex-column flex-align-center flex-justify-center mb-2 text-small px-4">
                <div class="d-flex flex-align-center flex-justify-center mb-2 row">
                    <span :class="renameItemDialog.resource.type.getMetroIcon(renameItemDialog.resource.path)" class="mr-2" />
                    <span>{{ renameItemDialog.parentPath }}</span>
                </div>
                <input type="text" class="input" v-model="renameItemDialog.name" v-fsitem />
            </div>
            <div class="dialog-actions">
                <button class="button js-dialog-close secondary my-3" @click="renameItem" :disabled="renameItemDialog.name == ''">{{ $t("Save") }}</button>
                <button class="button js-dialog-close" @click="closeRenameItemDialog">{{ $t("Close") }}</button>
            </div>
        </div>

        <!--------------------------FINESTRA PER CANCELLARE UNA CARTELLA O UN FILE-------------------------------->
        <div v-if="deleteItemDialog != null" class="dialog h-auto" style="min-height: fit-content;">
            <div class="dialog-title pl-10">{{ $t("Do you want delete selected item?") }}</div>
            <div class="text-small p-4">
                <span :class="deleteItemDialog.resource.type.getMetroIcon(deleteItemDialog.resource.path)" class="mr-2" />
                <span>{{ deleteItemDialog.resource.path }}</span>
            </div>
            <div class="dialog-actions">
                <button class="button js-dialog-close secondary my-3" @click="deleteItem">{{ $t("Yes") }}</button>
                <button class="button js-dialog-close alert" @click="closeDeleteItemDialog">{{ $t("No") }}</button>
            </div>
        </div>

        <!--------------------------FINESTRA PER RINOMINARE UN JOB-------------------------------->
        <div v-if="renameJobDialog != null" class="dialog light" style="min-height: fit-content; padding-top: 8px !important;padding-bottom:8px !important;">
            <div class="dialog-title pl-10">{{ $t("Rename Backup Job") }}</div>
            <div class="dialog-content d-flex flex-column flex-justify-center flex-align-center">
                <s class="mb-4">{{ renameJobDialog.oldName }}</s>
                <input type="text" v-model="renameJobDialog.newName" class="input w-75 mb-4" :placeholder="$t('Enter the new name of the backup')" v-fsitem />
            </div>
            <div class="dialog-actions">
                <button class="button js-dialog-close secondary my-3" @click="renameJob" :disabled="renameJobDialog.newName == ''">{{ $t("Save") }}</button>
                <button class="button js-dialog-close" @click="closeRenameJobDialog">{{ $t("Close") }}</button>
            </div>
        </div>

        <!------------------------------FINESTRA VISUALIZZAZIONE LOG DEI BACKUP IN HTML------------------------------>

        <div v-if="backupLog" id="backupLog" ref="backupLogDialog" v-on:keyup.esc="closeBackupLog()" class="light bg-light dialog center dialog-resizable backup-log-dialog">
            <div class="dialog-title backup-log-title">
                <span class="button square closer" @click="closeBackupLog()"></span>
            </div>

            <!-- il contenuto è l’elemento resizable -->
            <div class="dialog-content overflow py-5 px-8 backup-log-content" v-html="backupLog">
            </div>

            <!--<div class="resize-handle left"  data-side="left"  title="Drag to resize"></div>
            <div class="resize-handle right" data-side="right" title="Drag to resize"></div>-->
        </div>
        <!------------------------------FINESTRA VISUALIZZAZIONE ACQUISTO SERVIZI ONE------------------------------>
        <div v-if="buyDialog" id="buyLicense" class="bg-light light dialog center overflow w-33 dialog-topmost" v:on:keyup.esc="closeBuyDialog()">
            <div class="dialog-title">
                <span class="button square closer" @click="closeBuyDialog()"></span>
            </div>
            <div class="dialog-content pt-8">
                <div class="mb-2 px-4">
                    <div class="text-center">
                        <p class="p-4"><span class="mif-lock mif-4x" /></p>
                        <h3 class="text-bold">{{ $t("Feature not available") }}</h3>
                        <br>
                        <div class="p-4">
                            <h5>{{ $t("Upgrade your license to access this feature.") }}</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dialog-actions">
                <a class="button secondary" :href="upgradeLicenseUrl" target="_blank" rel="noopener noreferrer">{{ $t("Upgrade your license") }}</a>
                <a class="button" :href="contactUrl" target="_blank" rel="noopener noreferrer">{{ $t("Contact us") }}</a>
                <button class="button js-dialog-close" @click="closeBuyDialog()">{{ $t("Close") }}</button>
            </div>
        </div>


        <!--SCELTA DEL PC TRAMITE GRUPPO-->
        <div v-if="idPCForBackup != null" class="bg-light light dialog center  " v-on:keyup.esc="closeSelectPCForBackup()">
            <div class="dialog-title">{{ $t("Create Backup job") }}</div>
            <div class="dialog-content">
                <SelectPCByGroup @selectPC="(pc) => { idPCForBackup = pc.id }" :groupLabel="$t('Select a Group')" :pcLabel="$t('Select a Device')" :showSATestMsg="false" :selectIfOnline="true"/>
                <!---<div class="w-auto">
                    <div class="w-auto">
                        <label>{{ $t("Select a Group") }}</label>
                        <select v-model="groupForBackup" class="select">
                            <option v-for="group in $session.getGroups()" :key="group.id_group" :value="group">{{ group.name_group }}</option>
                        </select>
                    </div>
                    <div class="pt-5">
                        <label>{{ $t("Select a Device") }}</label>
                        <select :disabled="!groupForBackup"  v-model="idPCForBackup" class="select">
                            <option v-for="pc in $session.getPCList()" :key="pc.id" v-if="groupForBackup?.ids_computers.includes(pc.id)"
                            :disabled="!$root.connectionsStates[pc.id]" :value="pc.id">{{ pc.pc_name }}</option>
                        </select>
                    </div>
                </div>-->
            </div>
            <div class="dialog-actions">
                <button class="button secondary" @click="goToBackupPage()" :disabled="idPCForBackup == '' || !$root.connectionsStates[idPCForBackup]"> {{ $t("Create") }}</button>
                <button class="button js-dialog-close" @click="closeSelectPCForBackup">{{ $t("Close") }}</button>
            </div>
        </div>

        <ExportLogsDialog v-if="inputLogsType" :inputLogsType="inputLogsType" />

        <!-------------------------MINI DIALOGS---------------------------------------------------------------------------------------------->

        <Terminal />

        <DownloadItemsDialog v-if="showDownloadItemsDialog" />

        <CreateFolder v-if="createFolderObj != null" :createFolderObj="createFolderObj" />

        <ConfRestoreFromBackupJob v-if="confRestFromBkpJob_idPC != null" :idPC="confRestFromBkpJob_idPC" />

        <IRConnection v-if="ir_info != null" :ir_info="ir_info" />

    </div>
</template>
<script>
import GroupDialog from "../components/dialogs/view/GroupDialog"
import TeamDialog from "../components/dialogs/ticketing/TeamDialog"
import CustomerDialog from "../components/dialogs/ticketing/CustomerDialog"
import AssignGroupsToCustomers from "../components/dialogs/AssignGroupsToCustomers"
import InvoiceDialog from "../components/dialogs/ticketing/InvoiceDialog"
import InvoiceView from "../components/dialogs/ticketing/InvoiceView"
import UserDialog from "../components/dialogs/view/UserDialog"
import PolicyDialog from "./dialogs/view/PolicyDialog.vue";
import SchedulationDialog from "./dialogs/view/SchedulationDialog.vue";
//SERVICEACCOUNTS
import CloudServiceAccount from "./dialogs/serviceaccount/CloudServiceAccount";
import DatabaseServiceAccount from "./dialogs/serviceaccount/DatabaseServiceAccount";
import EmailServiceAccount from "./dialogs/serviceaccount/EmailServiceAccount";
import ESXIServiceAccount from "./dialogs/serviceaccount/ESXIServiceAccount";
import MicrosoftServiceAccount from "./dialogs/serviceaccount/MicrosoftServiceAccount";
import FTPServiceAccount from "./dialogs/serviceaccount/FTPServiceAccount";
import NetworkServiceAccount from "./dialogs/serviceaccount/NetworkServiceAccount";
//REPOSITORY
import Repository from "./dialogs/repository/Repository";
//BACKUP - SOURCE
import FolderSource from "./dialogs/backup/FolderSource";
import NetworkSource from "./dialogs/backup/NetworkSource";
import DriveImageSource from './dialogs/backup/DriveImageSource';
import DatabaseSource from './dialogs/backup/DatabaseSource';
import HyperVSource from './dialogs/backup/HyperVSource';
import ExchangeSource from './dialogs/backup/ExchangeSource';
import ESXiSourceDestination from './dialogs/backup/ESXiSourceDestination';
import MicrosoftSource from './dialogs/backup/MicrosoftSource';
//BACKUP - DESTINATION
import Destination from "./dialogs/backup/Destination";
//RESTORE
import ConfRestoreFromBackupJob from "./dialogs/restore/ConfRestoreFromBackupJob";
import RestoreFile from "./dialogs/restore/RestoreFile";
import DatabaseDestinationRestore from "./dialogs/restore/DatabaseDestinationRestore";
import DatabaseManualRestore from "./dialogs/restore/DatabaseManualRestore";
import ESXiDestinationRestore from "./dialogs/restore/ESXiDestinationRestore";
import ESXiManualRestore from "./dialogs/restore/ESXiManualRestore";
import ExchangeRestore from "./dialogs/restore/ExchangeRestore";
import HyperVRestore from "./dialogs/restore/HyperVRestore";
//VISTE
import BackupView from './dialogs/view/BackupView';
import SARepoView from './dialogs/view/SARepoView';
//UTILS
import { DefaultObjectBuilder } from '../models/DefaulfObjectBuilder';
import { isValid, decryptAES128, assignProperties, waitSeconds } from '../utils/utilitiesmodule';

import $ from 'jquery';
import CreateFolder from "./utils/CreateFolder.vue";
import PolicyDeviceDialog from "./dialogs/view/PolicyDeviceDialog.vue";
import { REPOSITORY_MESSAGES, SERVICEACCOUNT_MESSAGES } from "../utils/messages";
import SelectPCByGroup from "./utils/SelectPCByGroup.vue";
import ExportLogsDialog from "./dialogs/ExportLogsDialog.vue";
import Terminal from "./dialogs/Terminal.vue";
import DownloadItemsDialog from "./dialogs/DownloadItemsDialog.vue";
import RestoreView from "./dialogs/view/RestoreView.vue";
import IRConnection from "./dialogs/IRConnection.vue";
import ScriptDeploy from "./dialogs/ScriptDeploy.vue";
import { ScriptsHelper } from "../utils/objects";
import ExpiredLicenceAlert from "./dialogs/ExpiredLicenceAlert.vue";

export default {
    name: "Dialogs",
    components: {
        //SERVICEACCOUNTS
        CloudServiceAccount,
        DatabaseServiceAccount,
        EmailServiceAccount,
        ESXIServiceAccount,
        MicrosoftServiceAccount,
        FTPServiceAccount,
        NetworkServiceAccount,
        //REPOSITORY
        Repository,
        //BACKUP -SOURCE
        FolderSource,
        NetworkSource,
        DriveImageSource,
        DatabaseSource,
        HyperVSource,
        ExchangeSource,
        ESXiSourceDestination,
        MicrosoftSource,
        //BACKUP - DESTINATION
        Destination,
        //RESTORE
        RestoreFile,
        DatabaseDestinationRestore,
        DatabaseManualRestore,
        ESXiDestinationRestore,
        ESXiManualRestore,
        ExchangeRestore,
        HyperVRestore,
        //VISTE
        BackupView,
        RestoreView,
        SARepoView,
        GroupDialog,
        PolicyDialog,
		ScriptDeploy,
        UserDialog,
        SchedulationDialog,
        CreateFolder,
        PolicyDeviceDialog,

        SelectPCByGroup,

        ExportLogsDialog,

        Terminal,

        DownloadItemsDialog,

        ConfRestoreFromBackupJob,

        IRConnection,
        TeamDialog,
        CustomerDialog,
        AssignGroupsToCustomers,
        InvoiceDialog,
        InvoiceView,
        ExpiredLicenceAlert
    },
    created() {
        // 1) mappa evento → handler (stesse funzioni riutilizzate per on/off)
        this.handlers = {
            OPENSERVICEACCOUNTDIALOG: (type_or_serviceAccount) => this.openServiceAccountDialog(type_or_serviceAccount),
            CLOSESERVICEACCOUNTDIALOG: () => this.closeServiceAccountDialog(),

            OPENREPOSITORYDIALOG: (type_or_repository) => this.openRepositoryDialog(type_or_repository),
            CLOSEREPOSITORYDIALOG: () => this.closeRepositoryDialog(),

            OPENSOURCEDIALOG: (type_or_source) => this.openSourceDialog(type_or_source),
            CLOSESOURCEDIALOG: () => this.closeSourceDialog(),

            OPENDESTINATIONDIALOG: (type_or_destination) => this.openDestinationDialog(type_or_destination), // <- vedi nota sotto
            CLOSEDESTINATIONDIALOG: () => this.closeDestinationDialog(),

            OPENRESTOREDIALOG: (type, job) => this.openRestoreDialog(type, job),
            CLOSERESTOREDIALOG: () => this.closeRestoreDialog(),

            OPENBACKUPVIEW: (idBackup) => this.openBackupView(idBackup),
            CLOSEBACKUPVIEW: () => this.closeBackupView(),

            OPENRESTOREVIEW: (restoreId_or_obj, restoreName) => this.openRestoreView(restoreId_or_obj, restoreName),
            CLOSERESTOREVIEW: () => this.closeRestoreView(),

            OPENUSERVIEWDIALOG: (user, checkTFA) => this.openUserViewDialog(user, checkTFA),
            CLOSEUSERVIEWDIALOG: () => this.closeUserViewDialog(),

            OPENDEVICEPOLICYVIEWDIALOG: (device, policiesList) => this.openDevicePoliciesViewDialog(device, policiesList),
            CLOSEDEVICEPOLICYVIEWDIALOG: () => this.closeDevicePoliciesViewDialog(),

            OPENGROUPVIEWDIALOG: (group) => this.openGroupViewDialog(group),
            CLOSEGROUPVIEWDIALOG: () => this.closeGroupViewDialog(),

            OPENPOLICYVIEWDIALOG: (policy, computers) => this.openPolicyViewDialog(policy, computers),
            CLOSEPOLICYVIEWDIALOG: () => this.closePolicyViewDialog(),

			OPENSCRIPTDEPLOYDIALOG: (deployment) => this.openScriptDeployDialog(deployment),
			CLOSESCRIPTDEPLOYDIALOG: () => this.closeScriptDeployDialog(),
			OPENSCRIPTDEPLOYDETAILSDIALOG: (deployment) => this.openScriptDeployDialog(deployment),
			CLOSESCRIPTDEPLOYDETAILSDIALOG: () => this.closeScriptDeployDialog(),


            OPENSCHEDULATIONVIEWDIALOG: (policy) => this.openSchedulationViewDialog(policy),
            CLOSESCHEDULATIONVIEWDIALOG: (schedulationString) => this.closeSchedulationViewDialog(schedulationString),

            OPENCREATEFOLDERDIALOG: (createFolderObj) => this.openCreateFolderDialog(createFolderObj),
            CLOSECREATEFOLDERDIALOG: () => this.closeCreateFolderDialog(),

            OPENRENAMEITEMDIALOG: (resource, parentPath) => this.openRenameItemDialog(resource, parentPath),
            CLOSERENAMEITEMDIALOG: () => this.closeRenameItemDialog(),

            OPENDELETEITEMDIALOG: (resource) => this.openDeleteItemDialog(resource),
            CLOSEDELETEITEMDIALOG: () => this.closeDeleteItemDialog(),

            OPENRENAMEJOBDIALOG: (backupID, backupName) => this.openRenameJobDialog(backupID, backupName),
            CLOSERENAMEJOBDIALOG: () => this.closeRenameJobDialog(),

            OPENSERVICEACCOUNTVIEW: (serviceAccount) => this.openSARepoView(serviceAccount, null),
            CLOSESERVICEACCOUNTVIEW: () => this.closeSARepoView(),
            OPENREPOSITORYVIEW: (repository) => this.openSARepoView(null, repository),
            CLOSEREPOSITORYVIEW: () => this.closeSARepoView(),
            OPENSAREPOVIEW: (serviceAccount, repository) => this.openSARepoView(serviceAccount, repository),
            CLOSESAREPOVIEW: () => this.closeSARepoView(),

            OPENBACKUPLOG: (backupLog) => this.openBackupLog(backupLog),
            CLOSEBACKUPLOG: () => this.closeBackupLog(),

            OPENSELECTPCFORBACKUP: () => this.openSelectPCForBackup(),
            CLOSESELECTPCFORBACKUP: () => this.closeSelectPCForBackup(),

            CLOSEALLDIALOGS: () => this.closeAll(),

            OPENBUYDIALOG: () => this.openBuyDialog(),
            CLOSEBUYDIALOG: () => this.closeBuyDialog(),

            OPENEXPORTLOGSDIALOG: (inputLogsType) => this.openExportLogsDialog(inputLogsType),
            CLOSEEXPORTLOGSDIALOG: () => this.closeExportLogsDialog(),
            refreshPolicies: () => this.refreshPolicies(),

            OPENDOWNLOADITEMSDIALOG: () => { this.nOpenDialogs++; this.showDownloadItemsDialog = true },
            CLOSEDOWNLOADITEMSDIALOG: () => { this.nOpenDialogs--; if (this.nOpenDialogs < 0) this.nOpenDialogs = 0; this.showDownloadItemsDialog = false },

            OPENCONFRESTOREFROMBACKUPJOB: (idPC) => this.openConfRestoreFromBackupJob(idPC),
            CLOSECONFRESTOREFROMBACKUPJOB: () => this.closeConfRestoreFromBackupJob(),

            OPENIRCONNECTION: (ir_info) => this.openIRConnection(ir_info),
            CLOSEIRCONNECTION: () => this.closeIRConnection(),

            OPENTEAMDIALOG: (team) => this.openTeamDialog(team),
            CLOSETEAMDIALOG: () => this.closeTeamDialog(),

            OPENCUSTOMERDIALOG: (customer) => this.openCustomerDialog(customer),
            CLOSECUSTOMERDIALOG: () => this.closeCustomerDialog(),
            OPENASSIGNGROUPSTOCUSTOMERSDIALOG: () => this.openAssignGroupsToCustomersDialog(),
            CLOSEASSIGNGROUPSTOCUSTOMERSDIALOG: () => this.closeAssignGroupsToCustomersDialog(),

            OPENINVOICEDIALOG: (mode) => this.openInvoiceDialog(mode),
            CLOSEINVOICEDIALOG: () => this.closeInvoiceDialog(),

            OPENINVOICEVIEW: (invoice) => this.openInvoiceView(invoice),
            CLOSEINVOICEVIEW: () => this.closeInvoiceView(),

            OPENEXPIREDLICENCEALERT: () => this.openExpiredLicenceAlert(),
            CLOSEEXPIREDLICENCEALERT: () => this.closeExpiredLicenceAlert(),
        };

        // 2) registra tutti gli handler
        Object.entries(this.handlers).forEach(([evt, fn]) => {
            this.$root.$on(evt, fn);
        });



    },
    mounted: function () {
        //this.restoreView = {"id_computer":"e6df761f-5872-448f-a32a-76dccb3d4d86","id":"5df135eb-9ee4-418b-9ae5-7d22b81fda89","restore_name":"Test Virtual Machine NB-Lenovo_restored_20260129093530","restore_type":3,"backup_type":"RCT","backup_number":-1,"job_id":"333994c7-7aa4-4a42-b156-c4ca1cd8e26b","job_name":null,"restore_result":0,"error":"The file 'D:\\Test Veronica Hyper-V\\Test Virtual Hard Disk.vhdx' already exists.","error_id":"HvpRestoreError","dt_start_utc":"20260129083704","dt_end_utc":"20260129083707","processed_files":3,"processed_data":4334080,"log_filename":"C:\\ProgramData\\IperiusONE\\Restores\\ada31838-d86b-4dec-90b0-d1d808eb3b6f\\RES-HV-202601290937.log","source_properties":{"type":8,"items":[{"entityType":1,"path":"D:\\Test Veronica Hyper-V\\Test Virtual Machine NB-Lenovo\\"}],"options":{"vhdCustomFolder":"D:\\Test Veronica Hyper-V","copyNumber":"FULL"}},"destination_properties":{"type":3,"items":[{"entityType":27,"path":"Test Virtual Machine NB-Lenovo_restored_20260129093530","id":"F2BF0AF8-219B-47ED-9C0B-A05746292147"}]}};
        //this.restoreView={"id_computer":"e6df761f-5872-448f-a32a-76dccb3d4d86","id":"3d3ca169-b544-45a7-804a-9402dec5f14e","restore_name":"Test Virtual Machine NB-Lenovo_restored_20260128040624","restore_type":3,"backup_type":"RCT","backup_number":-1,"job_id":null,"job_name":"Hyper-V - Test Virtual Machine NB-Lenovo","restore_result":1,"error":"","error_id":"","dt_start_utc":"20260128150655","dt_end_utc":"20260128163245","processed_files":6,"processed_data":21483487744,"log_filename":"C:\\ProgramData\\IperiusONE\\Restores\\1d55db3f-2382-40c5-8988-38c4ea5dd398\\RES-HV-202601281606.log","source_properties":{"type":8,"items":[{"entityType":1,"path":"D:\\Test Veronica Hyper-V\\Test Virtual Machine NB-Lenovo\\"}],"options":{"vhdCustomFolder":"D:\\Test Veronica Hyper-V","copyNumber":"FULL"}},"destination_properties":{"type":3,"items":[{"entityType":27,"path":"Test Virtual Machine NB-Lenovo_restored_20260128040624","id":"F2BF0AF8-219B-47ED-9C0B-A05746292147"}]}};
    },
    data() {
        return {
            users: [],
            computers: [],
            group: null,
            policy: null,
            openSched: false, //apre la maschera di scelta della stringa CRON
            cronSchedulation: "",
            backupTree: null,
            user: null,
            checkTFA: {
                step1: null,
                step2: null
            },

            serviceAccount: null,

            repository: null,

            source: null,
            tmpSource: null,
            destination: null,


            restore: null,

            backupView: null,
            restoreView: null,

            createFolderObj: null,

            renameItemDialog: null,

            renameJobDialog: null,

            deleteItemDialog: null,

            sarepo: null,

            device: null,
            policiesList: null,

            backupLog: null,

            groupForBackup: null,
            idPCForBackup: null,

            nOpenDialogs: 0,

            buyDialog: false,
            upgradeLicenseUrl: process.env.VUE_APP_ECOMM_SITE_URL,
            contactUrl: process.env.VUE_APP_ECOMM_SITE_URL + 'en/contact/',
            inputLogsType: null,

            wait: false,
            handlers: null,
            cronSchedulation: null,

            showDownloadItemsDialog: false,

            confRestFromBkpJob_idPC: null,

            ir_info: null,

            team: null,
            customer: null,
            assignGroupsToCustomers: false,
            invoice: null,
            createInvoiceMode:null,
            invoiceView: null,

            backupLogDrag: null,
			scriptDeployment: false,
            expiredLicenceAlert: false

        }
    },

    methods: {

        async openServiceAccountDialog(type_or_serviceAccount) {
            this.nOpenDialogs += 1;

            if (typeof type_or_serviceAccount != "number") {
                var serviceAccount = type_or_serviceAccount;
                if (serviceAccount.crypted) {
                    //I seguenti campi arrivano cryptati, ma per utilizzarli, li decripto
                    serviceAccount.password = [undefined, null, ""].includes(serviceAccount.password) ? serviceAccount.password : decryptAES128(serviceAccount.password);
                    serviceAccount.client_secret = [undefined, null, ""].includes(serviceAccount.client_secret) ? serviceAccount.client_secret : decryptAES128(serviceAccount.client_secret);
                    serviceAccount.token = [undefined, null, ""].includes(serviceAccount.token) ? serviceAccount.token : decryptAES128(serviceAccount.token);
                    serviceAccount.refresh_token = [undefined, null, ""].includes(serviceAccount.refresh_token) ? serviceAccount.refresh_token : decryptAES128(serviceAccount.refresh_token);
                    serviceAccount.crypted = false;
                }
                this.serviceAccount = serviceAccount;

            }


            else if (!type_or_serviceAccount.isEmail()) {
                this.serviceAccount = DefaultObjectBuilder.getServiceAccount(type_or_serviceAccount);

            } else {
                //Se il service account è di tipo email, per costruire l'oggetto ho bisogno di alcuni dati relativi al provider selezionato
                var emailProviders = await this.$api.getEmailProviders();
                var selectedEmailProvider = emailProviders.find(ep => ep.Id.toString() == type_or_serviceAccount.toString());

                var app = DefaultObjectBuilder.getServiceAccount(type_or_serviceAccount, selectedEmailProvider);
                app.type = selectedEmailProvider.Id;
                app.type_name = selectedEmailProvider.Name;
                app.url = selectedEmailProvider.Url;
                //app.username="";
                //app.password="";
                app.use_ssl = selectedEmailProvider.UseSSL;
                app.port = selectedEmailProvider.Port;
                this.serviceAccount = app;
            }


        },

        closeServiceAccountDialog() {
            if (this.serviceAccount == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;
            this.$root.$emit("closeFileSystemSidebar");

            this.serviceAccount = null;

            $(".sourceDialog").removeClass("background");
            $(".destinationDialog").removeClass("background");
            $(".repositoryDialog").removeClass("background");
            $(".restoreDialog").removeClass("background");

            /* this.$router.push(this.$route.path); */
            this.$router.replace({ path: this.$route.path }).catch((err) => {
                // Ignora l'errore NavigationDuplicated
                if (err.name !== 'NavigationDuplicated') {
                    console.writeError(err);
                }
            });

        },

        openRepositoryDialog(type_or_repository) {
            this.nOpenDialogs += 1;

            if (typeof type_or_repository == "number") {
                this.repository = DefaultObjectBuilder.getRepository(type_or_repository);
                return;
            }

            //Se la sorgente viene aperta in modifica, controllo se il service account associato esiste ancora
            var selectedSA = this.$session.getServiceAccountWithID(type_or_repository.id_service_account);
            if (selectedSA != null) {
                this.repository = type_or_repository;
                return;
            }

            this.$root.toast(this.$t(SERVICEACCOUNT_MESSAGES.NOT_RETRIEVED), "warning");
            type_or_repository.id_service_account = -2;
            this.repository = type_or_repository;
        },

        closeRepositoryDialog() {
            if (this.repository == null)
                return;
            this.nOpenDialogs -= 1; if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;
            this.$root.$emit("closeFileSystemSidebar");

            this.repository = null;
            $(".destinationDialog").removeClass("background");
            this.$root.$emit("closeFileSystemSidebar");
            this.$router.replace({ path: this.$route.path }).catch((err) => {
                // Ignora l'errore NavigationDuplicated
                if (err.name !== 'NavigationDuplicated') {
                    console.writeError(err);
                }
            });

        },

        openSourceDialog(type_or_source) {
            this.nOpenDialogs += 1;

            //La sorgente viene aperta in create
            if (typeof type_or_source == "number") {
                this.source = DefaultObjectBuilder.getSource(type_or_source);
                return;
            }

            // alcuni tipi di backup non necessitano di un service account, come ad esempio Fiel Folder o Hyper-V
            if (this.$ONEServiceTypeInfo[type_or_source.type].needed_service_account) {

                // Se la sorgente viene aperta in modifica, controllo se il service account associato esiste ancora
                var selectedSA = this.$session.getServiceAccountWithID(type_or_source.id_service_account);

                if (selectedSA == null) {
                    this.$root.toast(this.$t(SERVICEACCOUNT_MESSAGES.NOT_RETRIEVED), "warning");
                    type_or_source.id_service_account = -2;
                }

            }

            // serve per passare alla dialog un altra variabile e non il reiferimento alal stessa variabile.
            // necessario per intercettare il cambiamento della source
            this.source = JSON.parse(JSON.stringify(type_or_source));


        },

        closeSourceDialog() {
            if (this.source == null)
                return;
            this.nOpenDialogs -= 1; if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;
            this.$root.$emit("closeFileSystemSidebar");
            this.source = null;

        },

        openDestinationDialog(type_or_destination) {
            this.nOpenDialogs += 1;
            if (typeof type_or_destination == "number") {
                this.destination = DefaultObjectBuilder.getDestination(type_or_destination);
                return;
            }

            if (type_or_destination.type == this.$ONEServiceType.FileFolder) {
                this.destination = type_or_destination;
                return;
            }

            if (type_or_destination.id_repository != -2) {
                //Se la sorgente viene aperta in modifica, controllo se il service account associato esiste ancora
                var selectedRepo = this.$session.getRepositoryWithID(type_or_destination.id_repository);
                if (selectedRepo != null) {
                    this.destination = type_or_destination;
                    return;
                }

                this.$root.toast(this.$t(REPOSITORY_MESSAGES.NOT_RETRIEVED), "warning");
                type_or_destination.id_repository = -2;
                type_or_destination.id_service_account = -2;
                this.destination = type_or_destination;
                return;
            }

            //Se la sorgente viene aperta in modifica, controllo se il service account associato esiste ancora
            var selectedSA = this.$session.getServiceAccountWithID(type_or_destination.id_service_account);
            if (selectedSA != null) {
                this.destination = type_or_destination;
                return;
            }

            this.$root.toast(this.$t(SERVICEACCOUNT_MESSAGES.NOT_RETRIEVED), "warning");
            type_or_destination.id_service_account = -2;
            this.destination = type_or_destination;
        },

        closeDestinationDialog() {
            if (this.destination == null)
                return;
            this.nOpenDialogs -= 1; if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;
            this.$root.$emit("closeFileSystemSidebar");

            this.destination = null;
        },

        openRestoreDialog(type, backup) {
            this.nOpenDialogs += 1;


            const preservePCRoom = true; // <— segnala che NON dobbiamo staccarci dal PC

            //Caso 1 : restore di file
            if (type.isRestoreFile()) {
                this.closeBackupView(preservePCRoom);

                this.createRoomPcData(backup);

                this.restore = DefaultObjectBuilder.getRestoreFile(type, backup);
                return;
            }

            //Caso 2 : restore automatico no file
            if (isValid(backup)) {

                this.closeBackupView(preservePCRoom);

                this.selectedJobId = backup.id;
                this.restore = DefaultObjectBuilder.getRestoreSource(type, backup);

                this.createRoomPcData(backup);

                return;
            }

            //Caso 3 : restore manuale no file
            this.restore = DefaultObjectBuilder.getRestoreSource(type);
            this.createRoomPcData();

        },

        closeRestoreDialog() {
            if (this.restore == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            }
            this.$root.$emit("closeFileSystemSidebar");

            this.restore = null;
        },

        async createRoomPcData(job) {
            if (!job) return;

            // Verifica che $route.path sia definito e controlla se contiene l'id
            const intoPCRoom = (this.$route.path || '').includes(job.id_computer);

            // Se non sono già nella "stanza PC", avvia la sottoscrizione
            if (!intoPCRoom) {
                await this.$root.startToListenPC(job.id_computer);
            }
        },

        async openBackupView(idBackup) {
            var job = await this.$api.getBackupWithID(idBackup);
            if (job == null) {
                return;
            }
            this.nOpenDialogs += 1;

            job.isRunning = "NA";
            job.progress = "NA";
            job.current_operation = "NA";

            this.backupView = job;
            this.$root.backupIDForView = idBackup;
        },

        closeBackupView(preservePCRoom = false) {
            if (this.backupView == null)
                return;
            this.nOpenDialogs -= 1; if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;

            this.$root.$emit("closeFileSystemSidebar");

            // salvo il flag nel root per leggerlo nel beforeDestroy
            this.$root.__preservePCRoomOnClose = !!preservePCRoom;

            this.backupView = null;
            this.$root.backupIDForView = null;
        },

        async openRestoreView(restoreId_or_obj, restoreName) {
            //se è stato passato l'id, recupero l'oggetto del restore tramite il suo ID
            if (typeof restoreId_or_obj == "string") {
                restoreId_or_obj = await this.$api.getRestoreWithID(idRestore, restoreName);
            }

            if (restoreId_or_obj == null) {
                return;
            }
            this.nOpenDialogs += 1;

            this.restoreView = restoreId_or_obj;
        },

        closeRestoreView() {
            if (this.restoreView == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;
            this.restoreView = null;
        },

        openDevicePoliciesViewDialog(device, policiesList) {
            this.closeAll();
            console.log("openDevicePoliciesViewDialog", device, policiesList);
            this.nOpenDialogs += 1;
            this.device = device;
            this.policiesList = policiesList;

        },

        closeDevicePoliciesViewDialog() {
            if (this.device == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;
            this.device = null;
        },

        openUserViewDialog(user, checkTFA) {
            this.closeAll();
            this.nOpenDialogs += 1;


            if (isValid(user)) {
                this.user = user;
            } else {
                this.user = DefaultObjectBuilder.getUser()
                this.user.id_master_account = this.$root.authObj.id_master_account;
            }

            if (isValid(checkTFA)) this.checkTFA = checkTFA;

        },

        closeUserViewDialog() {
            if (this.user == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;
            this.$root.$emit("closeFileSystemSidebar");

            this.user = null;
            this.checkTFA = {
                step1: null,
                step2: null
            };
            this.$router.replace({ path: this.$route.path }).catch((err) => {
                // Ignora l'errore NavigationDuplicated
                if (err.name !== 'NavigationDuplicated') {
                    console.writeError(err);
                }
            });
        },

        openGroupViewDialog(group) {
            this.nOpenDialogs += 1;

            if (isValid(group)) {
                this.group = group;
            } else {
                this.group = DefaultObjectBuilder.getGroup();
            }

        },
        closeGroupViewDialog() {
            if (this.group == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;
            this.$root.$emit("closeFileSystemSidebar");

            this.group = null;
            this.computers = null;
            this.users = null;

            this.$router.replace({ path: this.$route.path }).catch((err) => {
                // Ignora l'errore NavigationDuplicated
                if (err.name !== 'NavigationDuplicated') {
                    console.writeError(err);
                }
            });
        },

        async openPolicyViewDialog(policy, computers) {
            this.nOpenDialogs += 1;

            if (isValid(policy)) {
                this.policy = policy;
            } else {
                this.policy = DefaultObjectBuilder.getPolicy();
            }

            if (isValid(computers)) {
                this.computers = computers;
            } else {
                this.computers = this.$session.getPCList();
            }
        },


        closePolicyViewDialog() {
            if (this.policy == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;
            this.$root.$emit("closeFileSystemSidebar");

            this.policy = null;
            this.computers = null;

            if (isValid(this.$route.hash)) {
                this.$router.removeHash();
            }
            /*this.$router.replace({ path: this.$route.path }).catch((err) => {
                // Ignora l'errore NavigationDuplicated
                if (err.name!=='NavigationDuplicated') {
                    console.writeError(err);
                }
            });*/
        },

        // Questo metodo viene chiamato dopo la creazione o modifica di una policy
        // Se viene chiamato ed è aperta la UserDialog, significa che l'utnete ha voluto creare una nuova policy
        // Quindi, ricarico l'utente, per far apparire in lista la nuova policy
        async refreshPolicies() {
            if (this.user == null)
                return;
            const userID = this.user.id;
            this.user = null;
            await waitSeconds(0.5)
            this.user = await this.$api.getUser(userID);
        },

        openSchedulationViewDialog(cronSchedulation) {
            this.nOpenDialogs += 1;
            this.cronSchedulation = cronSchedulation;
            this.openSched = true;
        },
        closeSchedulationViewDialog(schedulationString) {
            if (this.cronSchedulation == null && !this.openSched)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;

            this.$root.$emit("REFRESHSCHEDULATION", schedulationString);

            if (this.policy != null && schedulationString != "") {
                if (this.policy.id_type == 2) {
                    this.policy.policy.update_time = schedulationString;
                }
                if (this.policy.id_type == 1) {
                    this.policy.policy.scheduling.splice(0, 1);
                    this.policy.policy.scheduling.push(schedulationString);
                }
            }
            this.cronSchedulation = null;
            this.openSched = false;
        },



        openCreateFolderDialog(createFolderObj) {
            this.nOpenDialogs += 1;
            this.createFolderObj = createFolderObj;
        },


        closeCreateFolderDialog() {
            if (this.createFolderObj == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            }
            this.createFolderObj = null;

        },

        openRenameItemDialog(resource, parentPath) {
            this.nOpenDialogs += 1;
            this.renameItemDialog = {
                resource: resource,
                parentPath: parentPath,
                name: resource.path.lastPartOfPath()
            };
        },

        async renameItem() {
            var oldPath = this.renameItemDialog.resource.path;
            var newPath = this.renameItemDialog.parentPath + "\\" + this.renameItemDialog.name;
            var renamed = await this.$root.socket("RenameItem", oldPath, newPath);

            this.$root.$emit("renameitemfeedback", renamed);
            if (renamed)
                this.closeRenameItemDialog();
        },
        closeRenameItemDialog() {
            if (this.renameItemDialog == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;
            this.renameItemDialog = null;
        },

        openDeleteItemDialog(resource) {
            this.nOpenDialogs += 1;
            this.deleteItemDialog = {
                resource: resource
            };
        },
        async deleteItem() {
            var deleted = await this.$root.socket("DeleteItem", this.deleteItemDialog.resource.path);
            this.$root.$emit("deleteitemfeedback", deleted);
            if (deleted)
                this.closeDeleteItemDialog();
        },
        closeDeleteItemDialog() {
            if (this.deleteItemDialog == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            }
            this.deleteItemDialog = null;
        },

        openRenameJobDialog(backupID, backupName) {
            this.nOpenDialogs += 1;
            this.renameJobDialog = {
                id: backupID,
                oldName: backupName,
                newName: ""
            };

        },

        async renameJob() {
            var renamed = await this.$api.renameBackup(this.renameJobDialog.id, this.renameJobDialog.oldName, this.renameJobDialog.newName);
            if (!renamed) return;

            renamed = await this.$root.socket("ChangeJobName", this.renameJobDialog.id, this.renameJobDialog.newName);

            if (renamed) this.closeRenameJobDialog();

        },
        closeRenameJobDialog() {
            if (this.renameJobDialog == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            }
            this.renameJobDialog = null;
        },

        openSARepoView(serviceAccount, repository) {
            this.sarepo = {
                repository: repository,
                serviceAccount: serviceAccount
            }
        },

        closeSARepoView() {
            if (this.sarepo == null)
                return;

            this.sarepo = null;
            //this.$router.removeHash(); // prototype implementato in main.js
        },

        openBackupLog(backupLog) {
            this.nOpenDialogs++;
            this.backupLog = backupLog;
            this.$nextTick(this.initBackupLogDrag);
        },

        closeBackupLog() {
            if (this.backupLog == null)
                return;
            this.destroyBackupLogDrag();
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            } this.backupLog = null;
        },

        openSelectPCForBackup() {
            this.nOpenDialogs = 1;
            this.groupForBackup = null;
            this.idPCForBackup = '';
        },


        goToBackupPage() {
            var url = '/computers/computer/' + this.idPCForBackup + '/backup';
            this.closeSelectPCForBackup();
            this.$router.replace(url);
        },

        closeSelectPCForBackup() {
            if (this.idPCForBackup == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            } this.groupForBackup = null;
            this.idPCForBackup = null;
        },

        openBuyDialog() {
            this.nOpenDialogs++;
            this.buyDialog = true;
        },

        closeBuyDialog() {
            if (!this.buyDialog)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            } this.buyDialog = false;
        },

		openScriptDeployDialog(deployment) {
			if (this.scriptDeployment) {
				return;
			}
			this.nOpenDialogs += 1;
			if (typeof deployment === 'string') {
				deployment = ScriptsHelper.getScriptDeploy(deployment);
			} else if (deployment) {
				deployment = JSON.parse(JSON.stringify(deployment));
			} else {
				deployment = ScriptsHelper.getScriptDeploy();
			}
			this.scriptDeployment = deployment;
		},

		closeScriptDeployDialog() {
			if (!this.scriptDeployment) {
				return;
			}
			this.nOpenDialogs -= 1;
			if (this.nOpenDialogs < 0) {
				this.nOpenDialogs = 0;
			}
			this.scriptDeployment = null;
		},

        openExportLogsDialog(inputLogsType) {
            this.closeAll();

            this.nOpenDialogs++;
            if (!inputLogsType) {
                inputLogsType = {
                    key: '',
                    id: '',
                    name: ''
                };
            }
            this.inputLogsType = inputLogsType;
        },

        closeExportLogsDialog() {
            if (this.inputLogsType == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            } this.inputLogsType = null;
        },

        openConfRestoreFromBackupJob(idPC) {
            this.nOpenDialogs++;
            this.confRestFromBkpJob_idPC = idPC;

        },

        closeConfRestoreFromBackupJob() {
            if (this.confRestFromBkpJob_idPC == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            } this.confRestFromBkpJob_idPC = null;
        },

        openIRConnection(ir_info) {
            this.nOpenDialogs++;
            this.ir_info = ir_info;
        },

        closeIRConnection() {
            if (this.ir_info == null)
                return;
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            }
            this.ir_info = null;
        },

        async openTeamDialog(team) {
            this.nOpenDialogs++;
            if (!team) {
                team = DefaultObjectBuilder.getTeam();
            } else if (typeof team == "string") { // team è l'id del team
                team = await this.$api.getTeam(team);
                if (!team) {
                    this.closeTeamDialog()
                    return;
                }
            }
            this.team = team;
        },

        closeTeamDialog() {
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            }
            this.team = null;
        },

        openCustomerDialog(customer) {
            this.nOpenDialogs++;
            if (!customer) {
                customer = DefaultObjectBuilder.getCustomer();
            }
            this.customer = customer;
        },

        closeCustomerDialog() {
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            }
            this.customer = null;
        },

        openAssignGroupsToCustomersDialog() {
            this.nOpenDialogs++;
            this.assignGroupsToCustomers = true;
        },

        closeAssignGroupsToCustomersDialog() {
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) this.nOpenDialogs = 0;
            this.assignGroupsToCustomers = false;
        },

        openInvoiceDialog(mode) {
            this.nOpenDialogs++;
            this.createInvoiceMode = mode;
            this.invoice = DefaultObjectBuilder.getInvoice();
        },

        closeInvoiceDialog() {
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            }
            this.createInvoiceMode = null;
            this.invoice = null;
        },

        openInvoiceView(invoice) {
            this.nOpenDialogs++;
            this.invoiceView = invoice;
        },

        closeInvoiceView() {
            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            }
            this.invoiceView = null;
        },

        openExpiredLicenceAlert() {
            if (this.expiredLicenceAlert) {
                return;
            }

            this.nOpenDialogs++;
            this.expiredLicenceAlert = true;
        },

        closeExpiredLicenceAlert() {
            if (!this.expiredLicenceAlert) {
                return;
            }

            this.nOpenDialogs -= 1;
            if (this.nOpenDialogs < 0) {
                this.nOpenDialogs = 0;
            }
            this.expiredLicenceAlert = false;
        },

        /**********************************UTILS**********************************************************/
        isValid(value) {
            return isValid(value);
        },

        initBackupLogDrag() {
            this.destroyBackupLogDrag();

            const dialog = this.$refs.backupLogDialog;
            if (!dialog) return;

            const header = dialog.querySelector('.backup-log-title');
            if (!header) return;

            const state = {
                isDragging: false,
                offsetX: 0,
                offsetY: 0,
                onPointerDown: null,
                onPointerMove: null,
                onPointerUp: null
            };

            const isInteractive = (target) =>
                !!target.closest?.('.closer, .button, button, a, input, textarea, select, [data-no-drag]');

            state.onPointerDown = (event) => {
                if (isInteractive(event.target)) return;

                const rect = dialog.getBoundingClientRect();
                state.isDragging = true;
                state.offsetX = event.clientX - rect.left;
                state.offsetY = event.clientY - rect.top;

                dialog.style.left = `${rect.left}px`;
                dialog.style.top = `${rect.top}px`;
                dialog.style.transform = 'none';
                dialog.classList.add('draggable-on');

                header.setPointerCapture?.(event.pointerId);
                event.preventDefault();
            };

            state.onPointerMove = (event) => {
                if (!state.isDragging) return;

                const maxLeft = window.innerWidth - dialog.offsetWidth;
                const maxTop = window.innerHeight - dialog.offsetHeight;
                const left = Math.max(0, Math.min(event.clientX - state.offsetX, maxLeft));
                const top = Math.max(0, Math.min(event.clientY - state.offsetY, maxTop));

                dialog.style.left = `${left}px`;
                dialog.style.top = `${top}px`;
                event.preventDefault();
            };

            state.onPointerUp = (event) => {
                if (!state.isDragging) return;

                state.isDragging = false;
                dialog.classList.remove('draggable-on');
                header.releasePointerCapture?.(event.pointerId);
            };

            header.addEventListener('pointerdown', state.onPointerDown);
            window.addEventListener('pointermove', state.onPointerMove, { passive: false });
            window.addEventListener('pointerup', state.onPointerUp);

            this.backupLogDrag = { header, state };
        },

        destroyBackupLogDrag() {
            if (!this.backupLogDrag) return;

            const { header, state } = this.backupLogDrag;
            header.removeEventListener('pointerdown', state.onPointerDown);
            window.removeEventListener('pointermove', state.onPointerMove);
            window.removeEventListener('pointerup', state.onPointerUp);
            this.backupLogDrag = null;
        },
        closeAll() {
            const closeMethodsNames = Object.keys(this).filter((prop) => prop.startsWith('close') && prop != "closeAll");
            closeMethodsNames.forEach((m) => this[m] && this[m]());
            this.nOpenDialogs = 0;
        }

    },
    beforeDestroy() {
        this.destroyBackupLogDrag();

        // 3) deregistra tutti gli handler con gli stessi riferimenti
        if (this.handlers) {
            Object.entries(this.handlers).forEach(([evt, fn]) => {
                this.$root.$off(evt, fn);
            });
            this.handlers = null;
        }
    }


}
</script>
<style scoped lang="css">
.loader.loader-topmost {
    z-index: 9998;
}

#backupLog {
    box-shadow: 0px 0px 10px 0px #00000029;
}

#backupLog.backup-log-dialog {
    display: flex !important;
    flex-direction: column;
    height: 75vh;
    max-height: 90vh !important;
    max-width: 80vw !important;
    min-height: 30vh !important;
    min-width: 33vw !important;
    overflow: hidden !important;
}

#backupLog .backup-log-title {
    cursor: move;
    flex: 0 0 auto;
    min-height: 44px;
}

#backupLog .backup-log-content {
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto !important;
}
</style>
